import { render, staticRenderFns } from "./positiveBalance.vue?vue&type=template&id=c2970720"
import script from "./positiveBalance.vue?vue&type=script&lang=js"
export * from "./positiveBalance.vue?vue&type=script&lang=js"
import style0 from "./positiveBalance.vue?vue&type=style&index=0&id=c2970720&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports